import type {Icon} from '@primer/octicons-react'

import {CustomIcon} from './CustomIcon'

// Borderless interior of the 16px Octicons FileDiffIcon, regridded for review badges.
export const ReviewChangesRequestedIcon: Icon = props => (
  <CustomIcon {...props} naturalWidth={12} naturalHeight={12}>
    <path d="M6 1a.75.75 0 0 1 .75.75V3.5h1.5a.75.75 0 0 1 0 1.5h-1.5v1.25a.75.75 0 0 1-1.5 0V5h-1.5a.75.75 0 0 1 0-1.5h1.5V1.75A.75.75 0 0 1 6 1ZM3.25 9a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5H4A.75.75 0 0 1 3.25 9Z" />
  </CustomIcon>
)
